import React from 'react';
import { StatusIndicator, SpaceBetween, Popover, Box } from '@amzn/awsui-components-react';
import "../styles.scss"


export interface MDATableCellProps {
    content: string | number | React.ReactNode;
    rowError?: string;
    cellError?: string;
}

/**
 * A reusable box component designed for use in table cells and headers.
 */
export default function MDATableCell({
    content,
    rowError,
    cellError
}: MDATableCellProps) {

    const hasError = (!!cellError) || (!!rowError)

    const cellView = ( 
        <div className={ hasError ? 'table-error-cell' : '' }>
            <Box>
            <SpaceBetween size='l' direction='horizontal'> 
                { content }
                { (!!cellError) && <StatusIndicator type={"error"}/> }
            </SpaceBetween>
            </Box>
        </div>
    )
    
    const cellViewWithPopover = hasError ? <Popover size="small" 
                                                    position="top" 
                                                    triggerType="text" 
                                                    content={cellError ? cellError : rowError}> 
                                                { cellView } 
                                            </Popover> 
                                            : 
                                            cellView;

    return cellViewWithPopover;
}
